import { usePDFPrintHook } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";
import { postApiFormData } from "../../helpers/AxiosInstance";
const CreateCreditNoteComponent = loadable(
  () => import("../../components/CreditNote/CreateCreditNote")
);

const CreateCreditNote = () => {
  const navigate = useNavigate();
  const [selectedOrder, setSelectedOrder] = useState(null);
  const { downloadPrint, isPrintLoading } = usePDFPrintHook();
  const [openPrintPopup, setOpenPrintPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const queryClient = useQueryClient();

  const { refetch: numbSeriresRefetch } = useGetHook({
    queryKey: ["number-serires-credit-note"],
    url: APIS.NUMBER_SERIRES,
    params: {
      type: "Credit Note",
    },
  });
  const { refetch: entryNoRefetch } = useGetHook({
    queryKey: ["credit-note"],
    url: APIS.JOURNAL_ENTRY,
    params: {
      type: "Credit Note",
      limit: 1,
      offset: 0,
    },
  });

  const handleCreate = async (values: any, isDraft: any, setError: any) => {
    setIsLoading(true);
    const url = APIS.JOURNAL_ENTRY;
    const formData = new FormData();
    formData.append("voucher_date", values?.voucher_date ?? null);
    formData.append("reference_number", values?.reference_number ?? "");
    values?.reference_date
      ? formData.append("reference_date", values?.reference_date)
      : null;
    formData.append("number_series", values?.number_series);
    formData.append("entry_number", values?.entry_number);
    isDraft
      ? formData.append("status", "Draft")
      : formData.append("status", "Success");
    formData.append("type", "Credit Note");
    if (values?.journal_account) {
      formData.append(
        "journal_account",
        JSON.stringify(values.journal_account)
      );
    }
    if (values?.attachment?.[0] && typeof values?.attachment !== "string") {
      formData.append("attachment", values?.attachment?.[0]);
    }
    values?.narration ? formData.append("narration", values?.narration) : null;
    try {
      const res = await postApiFormData({ url, formData, setError });
      if (res?.status === 201) {
        queryClient.invalidateQueries({
          queryKey: ["credit-note"],
          refetchType: "active",
        });
        if (!isDraft) {
          setSelectedOrder(res?.data?.id);
          setOpenPrintPopup(true);
        } else {
          navigate("/accounting/credit-note");
        }
        toast.success("Create Successfully");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["ledger-account"],
    navigateURL: "",
  });

  const handleCreateAccount = async (
    values: any,
    setOpenAccountPopup: any,
    setError: any
  ) => {
    const url = APIS.COA;
    const formData = {
      ...values,

      is_group: false,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setOpenAccountPopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handlePrint = async () => {
    const url = APIS.BILL_PRINT;
    let formData = {
      ids: [selectedOrder],
      type: "Credit Note",
    };

    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <div className={tw`grid grid-cols-2 `}>
        <h1 className={tw`font-semibold text-xl leading-10`}>
          Create Credit Note
        </h1>
      </div>

      <CreateCreditNoteComponent
        handleCreate={handleCreate}
        isLoading={isLoading}
        entryNoRefetch={entryNoRefetch}
        numbSeriesRefetch={numbSeriresRefetch}
        openPrintPopup={openPrintPopup}
        setOpenPrintPopup={setOpenPrintPopup}
        handlePrint={handlePrint}
        isPrintLoading={isPrintLoading}
        handleCreateAccount={handleCreateAccount}
        isPostLoading={isPostLoading}
      />
    </div>
  );
};

export default CreateCreditNote;
